import axios from "axios";
import { FETCH_EVENTS } from "../constants";

const setEvents = events => ({
  type: FETCH_EVENTS,
  events
});

export const fetchEvents = () => dispatch => {
  fetch('/input-data.json')
    .then((res) => res.json())
    .then((data) => {
      console.log(data);
      dispatch(setEvents(data));
    })
    .catch((err) => {
      console.log(err);
      throw new Error(err);
    });
};
